import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function for merging Tailwind CSS class names.
 * Used by shadcn/ui components.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Convert a maturity score (high = good, stored by backend) to a risk score
 * (high = bad, shown to users). Risk Score = 100 - maturityScore.
 *
 * Do NOT change backend storage or thresholds — transform only at display layer.
 */
export function toRiskScore(maturityScore: number): number {
  return Math.round(100 - maturityScore);
}
